<template :key="componentKey">
  <div>
    <v-toolbar
      :style="backgroundColor()"
      dark
      :class="{'fixed-toolbar': $vuetify.breakpoint.smAndDown}"
    >
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.smAndDown" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn icon v-if="$vuetify.breakpoint.mdAndUp" to="/settings">
        <v-icon>fas fa-user</v-icon>
      </v-btn>
      <v-toolbar-title>{{name}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
        <div id="wrap">
          <input v-model="tracking"
                 class="input-search"
                 v-on:keyup.enter="quickSearch"
                 id="search"
                 name="search"
                 type="text"
                 placeholder="Tracking No...">
          <v-icon class="search-icon">search</v-icon>
        </div>
      </v-toolbar-items>

      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn text to="/">Home</v-btn>
      </v-toolbar-items>

      <v-menu
        offset-y
        v-if="$vuetify.breakpoint.mdAndUp && itemsSubheaderManage"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            Manage
            <v-icon class="ml-2">fas fa-angle-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            link v-for="(item, index) in itemsSubheaderManage"
            :to=item.path
            :key="index"
          >
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu
        offset-y
        v-if="$vuetify.breakpoint.mdAndUp && itemsSubheaderDelivery"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            Delivery
            <v-icon class="ml-2">fas fa-angle-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            link v-for="(item, index) in itemsSubheaderDelivery"
            :to=item.path
            :key="index"
          >
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu
        offset-y
        v-if="$vuetify.breakpoint.mdAndUp && itemsSubheaderInventory"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            Inventory
            <v-icon class="ml-2">fas fa-angle-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            link v-for="(item, index) in itemsSubheaderInventory"
            :to=item.path
            :key="index"
          >
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu
        offset-y
        v-if="$vuetify.breakpoint.mdAndUp && itemsSubheaderClientTools"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            Client Tools
            <v-icon class="ml-2">fas fa-angle-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            link v-for="(item, index) in itemsSubheaderClientTools"
            :to=item.path
            :key="index"
          >
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <template>

        <v-btn class="tooltip" icon v-if="hasAPIDocumentationPermission && $vuetify.breakpoint.mdAndUp" link to='/faq'>
          <v-icon style="transform: translateY(13px);">fas fa-question</v-icon>
          <span class="tooltiptext3">FAQ</span>
        </v-btn>

        <v-btn class="tooltip" icon v-if="hasAPIDocumentationPermission && $vuetify.breakpoint.mdAndUp" @click="goApi">
          <v-icon>fas fa-book</v-icon>
          <span class="tooltiptext2">API Documentation</span>
        </v-btn>

        <v-btn class="tooltip" icon v-if="switchClientPermission && $vuetify.breakpoint.mdAndUp" @click="changeClientDialog=true">
          <v-icon>fas fa-exchange-alt</v-icon>
          <span class="tooltiptext">Change client</span>
        </v-btn>


        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="logout">
              <v-icon>logout</v-icon>
            </v-btn>
          </template>
          <span>Log out</span>
        </v-tooltip>

      </template>
    </v-toolbar>





    <v-navigation-drawer
      app
      class="height-viewport"
      v-model="drawer"
      absolute
      temporary
      :style="backgroundColor()"
      dark
    >
      <v-list-item>
        <v-list-item-icon>
          <v-btn icon to="/settings">
            <v-icon>fas fa-user</v-icon>
          </v-btn>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>

        <v-list-item link to='/'>
          <v-list-item-icon>
            <v-icon>fas fa-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          prepend-icon="fas fa-truck"
          color="white"
          v-if="itemsSubheaderDelivery"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Delivery</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="(item, index) in itemsSubheaderDelivery" :to=item.path :key="index">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="fas fa-tasks"
          color="white"
          v-if="itemsSubheaderManage"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Manage</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="(item, index) in itemsSubheaderManage" :to=item.path :key="index">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="fas fa-dolly-flatbed"
          color="white"
          v-if="itemsSubheaderInventory"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Inventory</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="(item, index) in itemsSubheaderInventory" :to=item.path :key="index">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="fas fa-tools"
          color="white"
          v-if="itemsSubheaderClientTools"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Client Tools</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="(item, index) in itemsSubheaderClientTools" :to=item.path :key="index">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item link v-if="hasAPIDocumentationPermission" @click="goApi">
          <v-list-item-icon>
            <v-icon>fas fa-book</v-icon>
          </v-list-item-icon>
          <v-list-item-title>API Documentation</v-list-item-title>
        </v-list-item>

        <v-list-item link v-if="switchClientPermission" @click="changeClientDialog=true">
          <v-list-item-icon>
            <v-icon>fas fa-exchange-alt</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Change Client</v-list-item-title>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list
          nav
          dense
        >
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>

    </v-navigation-drawer>

    <v-dialog
      v-model="changeClientDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Choose a Client</h3>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            hide-no-data
            v-model="client"
            :items="clients"
            item-text="name"
            label="Choose the Client"
            return-object
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn text color="teal accent-4" @click="goBackToInitialClient" v-if="switched_client">
            <v-icon left>arrow_back</v-icon>
            Go back to my initial user
          </v-btn>
          <v-btn text color="blue-grey lighten-2" @click="changeClientDialog=false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="changeClient">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </div>
</template>

<script>
    import axios from 'axios';
    import router from '../../modules/router';
    import {createNamespacedHelpers} from 'vuex';

    const {mapState: authState, mapMutations: authMutations, mapGetters: authGetters, mapActions: authActions} = createNamespacedHelpers("auth");
    import getStopsFromTracking from "../pages/Delivery/Search.vue";

    export default {
        name: 'ClientHeader',
        data() {
            return {
                Items: router.routes,
                tracking: '',
                mouseOver: false,
                searchBar: false,
                headers: [
                    {text: 'Client Name', value: 'clientName'},
                    {text: 'Address', value: 'address'},
                    {text: 'Region', value: 'region'},
                    {text: 'Invoice No', value: 'invoice'},
                    {text: 'Tracking Id', value: 'tracking'},
                ],
                footers: [
                    'Contact Us'
                ],
                isMobile: window.innerWidth < 600,
                showToolBar: true,
                changeClientDialog: false,
                client: null,
                componentKey: 0,
                showSubheader: false,
                drawer: null,
            }
        },
        methods: {
            ...authActions([
                'switch_user',
                'switch_client',
                'restore_user'
            ]),
            changeUser() {
                this.changeUserDialog = false;
                this.switch_user(this.user.id);
            },
            goBackToInitialUser() {
                this.changeUserDialog = false;
                this.restore_user();
            },
            changeClient() {
                this.changeClientDialog = false;
                this.switch_client(this.client.id);
            },
            goBackToInitialClient() {
                this.changeClientDialog = false;
                this.restore_user();
            },
            logout() {
                this.$store.commit('auth/logout');
                this.$store.commit('auth/setRedirect', this.$router.currentRoute.fullPath);
                this.$router.replace('/login');
            },
            quickSearch() {
                if (this.tracking != undefined && this.tracking != null && this.tracking !== '') {
                    this.$router.replace('/search?tracking=' + this.tracking)
                } else {
                    this.$router.replace('/search')
                }
                if (this.$route.name === 'Search') {
                    window.location.reload();
                }
                this.tracking = '';
            },
            backgroundColor: function () {
                if (process.env.NODE_ENV === "development") {
                    return {background: '#E41414'}
                } else {
                    return {background: '#1357a4'}
                }
            },
            goApi() {
                if (this.$store.getters['auth/isInternalUser']) {
                    window.open(process.env.API_URL + '/documentation/private/index.html?key='+ encodeURI(this.$store.state.auth.key), '_blank');
                } else {
                    window.open(process.env.API_URL + '/documentation/public/index.html?key='+ encodeURI(this.$store.state.auth.key), '_blank');
                }
            }
        },
        mounted() {
            if (this.isMobile) {
                this.showToolBar = false;
            }
        },
        computed: {
            ...authState([
                'key',
                'login_method',
                'is_logged_in',
                'switched_user',
                'switched_client'
            ]),
            ...authGetters([
                'name',
                'client_name',
                'client_logo',
                'username',
                'user_avatar',
                'isInternalUser',
                'isAdmin',
                'hasAPIDocumentationPermission',
                'hasPermission',
                'hasPermissionRegion',
                'hasPermissionRegionId',
                'permissionRegions'
            ]),
            logoutIcon: function () {
                return this.mouseOverDoor ? 'fas fa-door-open' : 'fas fa-door-closed'
            },
            switchUserPermission: function () {
                return this.switched_user || this.isAdmin;
            },
            switchClientPermission: function () {
                if (this.clients === null) return this.switched_client;
                return this.switched_client || this.clients.length > 1;
            },
            itemsSubheaderManage: function () {
                // Taking items we want to display on subheader 'Manage'+ handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Manage'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return !route.meta.internalOnly && this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                if (itemToolbar.length !== 0) {
                    return itemToolbar
                } else return false;
            },
            itemsSubheaderInventory: function () {
                // Taking items we want to display on subheader 'Inventory' + handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Inventory'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return !route.meta.internalOnly && this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                if (itemToolbar.length !== 0) {
                    return itemToolbar
                } else return false;
            },
            itemsSubheaderDelivery: function () {
                // Taking items we want to display on subheader drawer + handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Delivery'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return !route.meta.internalOnly && this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                return itemToolbar
            },
            itemsSubheaderClientTools: function () {
                let itemToolbar = router.routes.filter((item) => {
                    return item.meta.subheader === 'Client tools';
                }).filter((route) => {
                    if (route.meta.internalOnlyBypass && this.hasPermission(route.meta.internalOnlyBypass)) {
                        return true;
                    }
                    return !route.meta.internalOnly && route.meta.permission && this.hasPermission(route.meta.permission);
                });
                if (itemToolbar.length !== 0) {
                    return itemToolbar
                } else return false;
            },
        },
        asyncComputed: {
            async users() {
                if (this.isAdmin) {
                    return await axios.get(process.env.API_URL + '/users')
                        .then((response) => {
                            if (response.status === 200) {
                                return response.data;
                            } else {
                                return [];
                            }
                        })
                        .catch((error) => {
                            return [];
                        })
                } else return [];
            },
            async clients() {
                if (this.$store.getters['auth/user_id'] <= 0) return [];
                return await axios.get(process.env.API_URL + '/clients')
                    .then((response) => {
                        if (response.status === 200) {
                            return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                        } else {
                            return [];
                        }
                    })
                    .catch((error) => {
                        return [];
                    })
            }
        },
    }

</script>

<style scoped>

  >>> .v-toolbar__content {
    padding-bottom: 0;
    padding-top: 0;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: 100%;
  }

  #wrap {
    display: inline-block;
    position: relative;
    height: 64px;
  }

  >>> input.input-search {
    height: 30px;
    font-size: 16px;
    display: inline-block;
    border: none;
    outline: none;
    color: white;
    padding-right: 25px;
    width: 0px;
    position: absolute;
    top: 20px;
    right: 15px;
    background: none;
    z-index: 3;
    transition: width .4s cubic-bezier(0.000, 0.795, 0.000, 1.000);
    cursor: pointer;
  }

  >>> input.input-search:focus {
    cursor: text;
    width: 140px;
    z-index: 1;
    border-bottom: 1px solid white;
  }

  >>> input.input-search:hover {
    width: 140px;
    z-index: 1;
    border-bottom: 1px solid white;
    cursor: text;
    color: white;
  }

  >>> input.input-search::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }

  >>> input.input-search:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: white;
  }

  >>> input.input-search::-ms-input-placeholder { /* Microsoft Edge */
    color: white;
  }

  .search-icon {
    position: absolute;
    top: 20px;
    right: 15px;
    display: inline-block;
  }

  >>>.height-viewport {
    height: 100vh !important;
  }

  .fixed-toolbar {
    height: 56px;
    position: fixed;
    z-index: 3;
    width: 100%;
  }


  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 135px;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 6px 6px;
    border-radius: 4px;
    position: absolute;
    z-index: 100;
    bottom: -210%;
    left: 35%;
    margin-left: -60px;
    opacity: 1;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    text-transform: lowercase;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 0.8;
  }

  /* Tooltip text */
  .tooltip .tooltiptext2 {
    visibility: hidden;
    width: 165px;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 6px 6px;
    border-radius: 4px;
    position: absolute;
    z-index: 100;
    bottom: -210%;
    left: 35%;
    margin-left: -60px;
    opacity: 1;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    text-transform: lowercase;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext2 {
    visibility: visible;
    opacity: 0.8;
  }

  /* Tooltip text */
  .tooltip .tooltiptext3 {
    visibility: hidden;
    width: 165px;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 6px 6px;
    border-radius: 4px;
    position: absolute;
    z-index: 100;
    bottom: -210%;
    left: 35%;
    margin-left: -60px;
    opacity: 1;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    text-transform: uppercase;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext3 {
    visibility: visible;
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/ClientHeader.vue